import { lockBody, unlockBody } from "./helpers/body-lock-toggle";

window.addEventListener('load', () => {
    const staffSharePage = document.querySelector('.page-staff-share');
    const staffShareFormModal = document.querySelector('.staff-share-form-modal');

    if (staffSharePage && staffShareFormModal) {

        staffSharePage.addEventListener('click', (event) => {
            const clickedEventItem = event.target;

            if (clickedEventItem.hasAttribute('data-open-form-modal')) {
                openLightBox();
            }

            if (clickedEventItem.hasAttribute('data-lightbox-close')) {
                closeLightBox();
            }
        });

        function closeLightBox() {
            staffShareFormModal.dataset.active = 'false';
            unlockBody();
            setTimeout(() => {
                staffShareFormModal.dataset.hidden = 'true';
            }, 300);
        }

        function openLightBox() {
            staffShareFormModal.dataset.hidden = 'false';
            lockBody();
            setTimeout(() => {
                staffShareFormModal.dataset.active = 'true';
            }, 50);
        }
    }
});
